import { PrimaryButton } from 'src/styles/globalStyles/buttonStyles.styled';
import {
  EmptyTableWrapper,
  EmptyContent,
  EmptyIconWrapper,
  EmptyContentWrapper,
  EmptyContentTitle,
  EmptyContentSubtitle,
  NoNotesIcon,
  ButtonsWrapper,
} from './EmptyNotes.styled';
import { Add20Regular } from '@fluentui/react-icons';
import { Button } from '@fluentui/react-components';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

export const EmptyNotes = () => {
  const { toggleTicketDetails, toggleInputField } = useServiceDeskContext();
  return (
    <EmptyTableWrapper>
      <EmptyContent>
        <EmptyIconWrapper>
          <NoNotesIcon />
        </EmptyIconWrapper>
        <EmptyContentWrapper>
          <EmptyContentTitle>There are no notes to show</EmptyContentTitle>
          <EmptyContentSubtitle>
            Once a note is submitted, youll find it here.
          </EmptyContentSubtitle>
        </EmptyContentWrapper>
        <ButtonsWrapper>
          <PrimaryButton
            style={{ width: '100%' }}
            icon={<Add20Regular />}
            iconPosition="before"
            onClick={() => toggleInputField(true)}
          >
            Add note
          </PrimaryButton>
          <Button
            style={{ width: '100%' }}
            onClick={() => toggleTicketDetails('', '', false)}
          >
            Back to Ticket List
          </Button>
        </ButtonsWrapper>
      </EmptyContent>
    </EmptyTableWrapper>
  );
};
